import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import DashboardLayout from '../../components/layouts/dashboard/DashboardLayout';
import PolicyTabs from '../../components/dashboard/policy/PolicyTabs';
import PolicyInformation from '../../components/dashboard/policy/PolicyInformation';
import PolicyFinancials from '../../components/dashboard/policy/PolicyFinancials';
import PolicyCoverage from '../../components/dashboard/policy/PolicyCoverage';
import PolicyFiles from '../../components/dashboard/policy/PolicyFiles';
import { EmptyState } from '../../components/dashboard/common/StyledComponents';
import { PrimaryButton, ClaimButton, PlusIcon } from '../../components/dashboard/common/Buttons';

// Helper function for date formatting
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(date);
};

// Helper function to format currency
const formatCurrency = (amount) => {
  if (!amount) return '£0';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

const PPPolicy = () => {
  const location = useLocation();
  const selectedPolicy = location.state?.policy;
  const [activeTab, setActiveTab] = useState('overview');

  // Map Pipedrive data to our policy data structure
  const policyData = {
    policyNumber: selectedPolicy?.policyNumber || '',
    coverage: selectedPolicy?.typeOfCover || '',
    startDate: formatDate(selectedPolicy?.startDate),
    renewalDate: formatDate(selectedPolicy?.renewalDate),
    premium: {
      amount: formatCurrency(selectedPolicy?.annualPremium),
      schedule: selectedPolicy?.paymentSchedule || ''
    },
    excess: {
      general: formatCurrency(selectedPolicy?.excess)
    },
    limits: {
      aggregate: formatCurrency(selectedPolicy?.coverLimitAggregate),
      perClaim: formatCurrency(selectedPolicy?.coverLimitPerClaim)
    },
    payment: {
      method: selectedPolicy?.paymentMethod || '',
      status: selectedPolicy?.status || ''
    },
    files: [] // TODO: Add files integration
  };

  const tabs = [
    { id: 'overview', label: 'Policy Overview' },
    { id: 'coverage', label: 'Coverage Details' },
    { id: 'files', label: 'Documents' },
    { id: 'claims', label: 'Claims' },
    { id: 'payments', label: 'Payment History' },
  ];

  const handleEditCover = () => {
    console.log('Edit cover clicked');
  };

  const handleMakeClaim = () => {
    console.log('Make a claim clicked');
  };

  const handleFinancialSave = (field, value) => {
    console.log('Saving financial detail:', field, value);
    // Here you would update the policy data
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <>
            <PolicyInformation policyData={policyData} />
            <PolicyFinancials policyData={policyData} onSave={handleFinancialSave} />
          </>
        );
      case 'coverage':
        return <PolicyCoverage policyData={policyData} onEditCover={handleEditCover} />;
      case 'files':
        return <PolicyFiles files={policyData.files} />;
      case 'claims':
        return (
            <EmptyState>No claims available</EmptyState>
        );
      case 'payments':
        return (
            <EmptyState>No payment history available</EmptyState>
        );
      default:
        return null;
    }
  };

  const actions = (
    <>
      <PrimaryButton onClick={handleEditCover}>
              Edit Cover
      </PrimaryButton>
            <ClaimButton onClick={handleMakeClaim}>
              <PlusIcon />
              Make A Claim
            </ClaimButton>
    </>
  );

  return (
    <DashboardLayout title="Policy Details" currentPath="/dashboard/pp-policy">
      <PolicyTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        actions={actions}
      />
      {renderContent()}
    </DashboardLayout>
  );
};

export default PPPolicy; 